<template>
    <div id="screen-footer" :class="{'isTop':!isTop}">
        <div class="pc">
            <div class="footer-box">
                <div class="left-box">
                    <div class="one">
                        <img class="logo" src="@/assets/nav/DF-logo.webp" alt="">
                    </div>
                    <div class="two">
                        <div class="icon-box">
                            <div class="img img1" @click="toUrl('https://mall.jd.com/index-1000340428.html?from=pc')"></div>
                            <div class="img img2" @click="toUrl('https://dfqcpj.tmall.com/shop/view_shop.htm')"></div>
                            <div class="img img3">
                                <div class="hover-box">
                                    <img src="@/assets/flagship-store/example-picture.jpeg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="phone">官方客服电话：<span>400-189-9507</span></div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="card">
                        <div class="text-one">DF旗舰店</div>
                        <div class="text-two" @click="toUrl('/flagship-store/online-store')">DF线上旗舰店</div>
                        <div class="text-three" @click="toUrl('/flagship-store/xx')">DF线下旗舰店</div>
                    </div>
                    <div class="card">
                        <div class="text-one">关于DF</div>
                        <div class="text-two" @click="toUrl('/about-df/about-brand')">关于品牌</div>
                        <div class="text-three" @click="toUrl('/about-df/consult')">最新资讯</div>
                    </div>
                    <!-- <div class="card">
                        <div class="text-one">DF产品</div>
                        <div class="text-two" @click="toUrl('/product/series')">启停系列</div>
                        <div class="text-three" style="height:0.16rem;cursor: default;"></div>
                    </div> -->
                    <div class="card">
                        <div class="text-one">帮助与支持</div>
                        <div class="text-two" @click="toUrl('/support/download')">物料下载中心</div>
                        <div class="text-three" @click="toUrl('/support/to-join')">申请旗舰店</div>
                    </div>
                    <div class="copy-right">
                        <span class="text1">COPYRIGHT © 2016 骆驼集团股份有限公司 ALL RIGHTS RESERVED</span>
                        <span class="text2">备案号：鄂ICP备15000576号-3</span>  
                        <img src="@/assets/nav/police-shield.webp" alt="">
                        <span class="text3">鄂公网安备 42060602000269号</span>
                    </div>
                </div>
            </div>
            <div class="footer-box2">
                <div class="left-box">
                    <div class="one">
                        <img class="logo" src="@/assets/nav/DF-logo.webp" alt="">
                    </div>
                    <div class="two">
                        <div class="icon-box">
                            <img src="@/assets/nav/jd-icon.webp" alt="" >
                            <img src="@/assets/nav/tm-icon.webp" alt="" >
                            <img src="@/assets/nav/dy-icon.webp" alt="">
                        </div>
                        <div class="phone">官方客服电话：<span>400-189-9507</span></div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="card">
                        <div class="text-one">DF旗舰店</div>
                        <div class="text-two">DF线上旗舰店</div>
                        <div class="text-three">DF线下旗舰店</div>
                    </div>
                    <div class="card">
                        <div class="text-one">关于DF</div>
                        <div class="text-two">关于品牌</div>
                        <div class="text-three">最新资讯</div>
                    </div>
                    <div class="card">
                        <div class="text-one">DF产品</div>
                        <div class="text-two">启停系列</div>
                        <!-- <div class="text-three">其他</div> -->
                    </div>
                    <div class="card">
                        <div class="text-one">帮助与支持</div>
                        <div class="text-two">物料下载中心</div>
                        <div class="text-three">申请旗舰店</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="phones">
            <div class="list">
                <div class="list-item" @click="toUrl('https://mall.jd.com/index-1000340428.html?from=pc')">
                    <div class="imgs">
                        <img src="@/assets/nav/phone/jd.webp">
                    </div>
                    <div>
                        京东官方旗舰店
                    </div>
                </div>
                <div class="list-item" @click="toUrl('https://dfqcpj.tmall.com/shop/view_shop.htm')">
                    <div class="imgs">
                        <img src="@/assets/nav/phone/tm.webp">
                    </div>
                    <div>
                        天猫官方旗舰店
                    </div>
                </div>
                <div class="list-item" @click="toUrl('https://v.douyin.com/iMsBCaY9/ 0@9.com')">
                    <div class="imgs">
                        <img src="@/assets/nav/phone/dy.webp">
                    </div>
                    <div>
                        官方抖音
                    </div>
                </div>
            </div>
            <div class="tel">
                <span>官方客服电话：</span>
                <span style="color:#FFF337">400-189-9507</span>
            </div>
            <div class="line"></div>
            

       

            <div class="content">
                <div>
                    <span>COPYRIGHT © 2016 骆驼集团股份有限公司 ALL RIGHTS RESERVED</span>
                </div>
                <div>
                   
                    <span>备案号：鄂ICP备15000576号-3</span>    
                </div>
                <div style="display: flex;align-items: center;justify-content: center">
                    <img src="@/assets/nav/phone/er.webp">
                    <span>鄂公网安备 42060602000269号</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        isTop:{
            type:Boolean,
            default:true
        }
    },
    methods:{
        toUrl(path){
            if(path.indexOf('http')==-1){
                this.$router.push({
                    path
                },()=>{})
            }else{
                window.open(path,'_blank')
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .phones{
        display: none !important;
    }
#screen-footer{
    padding-top: 0.6rem;
}
.isTop{
    padding-top: 0 !important;
}
.footer-box2{
    display: none;
}
.footer-box {
    position: relative;
    // margin-top: 0.6rem;
    background: #000000;
    height: 3rem;
    display: flex;
    justify-content: space-between;
    scroll-snap-align: start;
    .left-box {
        display: flex;

        .one {
            width: 5.272rem;
            height: 3rem;
            background: url('~@/assets/nav/left-bg.webp') no-repeat;
            background-size: 100% 100%;
            

            .logo {
                margin-top: 0.73rem;
                margin-left: 1.37rem;
                width: 2.432rem;
                height: 0.832rem;
            }
        }

        .two {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            .icon-box {
                margin-top: 0.56rem;
                display: flex;
                .img {
                    width: 0.68rem;
                    height: 0.68rem;
                    cursor: pointer;
                    overflow: hidden;
                }
                .img1{
                    background: url('~@/assets/nav/jd-icon.webp') no-repeat;
                    background-size: 100% 100%;
                    transition-duration: 1s;
                }
                .img2{
                    background: url('~@/assets/nav/tm-icon.webp') no-repeat;
                    background-size: 100% 100%;
                    transition-duration: 1s;
                }
                .img3{
                    position: relative;
                    background: url('~@/assets/nav/dy-icon.webp') no-repeat;
                    background-size: 100% 100%;
                    transition-duration: 1s;
                    .hover-box{
                        position: absolute;
                        z-index: 2;
                        top: -3.93rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.64rem;
                        height: 3.93rem;
                        opacity: 0;
                        transition-duration: 0.5s;
                        box-shadow: 0rem 0rem 0.4rem 0.1rem #d6d7d9;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .img+.img {
                    margin-left: 0.36rem;
                }
                .img1:hover{
                    background: url('~@/assets/nav/jd-icon2.webp') no-repeat;
                    background-size: 100% 100%;
                }
                .img2:hover{
                    background: url('~@/assets/nav/tm-icon2.webp') no-repeat;
                    background-size: 100% 100%;
                }
                .img3:hover{
                    background: url('~@/assets/nav/dy-icon2.webp') no-repeat;
                    background-size: 100% 100%;
                    overflow: visible;
                    .hover-box{
                        opacity: 1;
                    }
                }
            }

            .phone {
                text-align: left;
                margin-top: 0.28rem;
                font-family: 'SourceHanSansCN-Regular';
                font-size: 0.16rem;
                font-weight: 400;
                color: #FFFFFF;
                letter-spacing: 0.024rem;
                span {
                    font-size: 0.24rem;
                    color: #FFF337;
                }
            }
        }
    }

    .right-box {
        margin-right: 0.45rem;
        text-align: left;
        height: 100%;
        display: flex;
        overflow: hidden;
        .card {
            margin-top: 0.56rem;
            margin-right: 0.92rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            // justify-content: center;

            .text-one {
                font-size: 0.2rem;
                font-weight: bold;
                color: #FFFFFF;
            }

            .text-two {
                margin-top: 0.424rem;
                font-size: 0.16rem;
                font-weight: 400;
                color: #EAEBF0;
                transition-duration: 0.5s;
                cursor: pointer;
                line-height: 0.16rem;
            }
            .text-three {
                margin-top: 0.231rem;
                font-size: 0.16rem;
                font-weight: 400;
                color: #EAEBF0;
                cursor: pointer;
                line-height: 0.16rem;
            }
            .text-two:hover{
                color: #FFF337;
            }
            .text-three:hover{
                color: #FFF337;
            }

            
        }
        
    }
    .copy-right{
            position: absolute;
            left: 5.27rem;
            bottom: 0.34rem;
            display: flex;
            align-items: center;
            .text1,.text2,.text3{
                font-size: 0.12rem;
                font-family: FZLanTingHeiS-R-GB;
                font-weight: 400;
                
                line-height: 0.12rem;
            }
            .text1{
                color: #FFFFFF;
            }
            .text2{
                margin-left: 0.4rem;
                color: #E4E4E4;
            }
            .text3{
                margin-left: 0.09rem;
                color: #E4E4E4;
            }
            img{
                margin-left: 0.4rem;
                width: 0.2rem;
                height: 0.2rem;
            }
        }
}
}
@media screen and (max-width: 767px) {
.phones{
    height: 4.74rem;
    background: #000000;
    padding:0.77rem 0.56rem 0;
    .list {
        display: flex;
        justify-content: space-between;
        &-item{
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width:0.48rem;
                height: 0.4rem;
                margin-bottom: 0.15rem;
            }
            div{
                font-family: FZLanTingHeiS-R-GB;
                font-weight: 400;
                font-size: 0.24rem;
                color: #D4D4D4;
            }

        }
    }
    .tel{
        border-bottom: 0.02rem dashed #666;
        margin-top: 0.4rem;
        padding-bottom: 0.4rem;
        margin-bottom: 0.4rem;
        text-align: center;
        span{
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            font-size: 0.24rem;
            color: #D4D4D4;
        }
    }
    .content{
        div{
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 0.20rem;
            color: #D4D4D4;
            line-height: 0.36rem;
            img{
                height: 0.3rem;
                width: 0.26rem;
                margin-right: 0.1rem;
            }
            span{
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 0.20rem;
                color: #D4D4D4;
                line-height: 0.36rem;
            }
        }
    }

}
}
</style>